"use client";

import { useRouter } from "next/navigation";
import { useEffect } from "react";
import type { Locale } from "@/lib/i18n-config";
import { getContactPath } from "@/lib/routing";

/** Redirects /book to /contact (client-side for static export). */
export default function BookRedirect({ locale }: { locale: Locale }) {
  const router = useRouter();
  useEffect(() => {
    router.replace(getContactPath(locale));
  }, [locale, router]);
  return null;
}
